module.exports = __webpack_public_path__ + "img/carousel-1.a494188a.png";